"use client";

import { cn } from "@/lib/utils";
import { type ReactNode } from "react";

interface GlassCardProps {
  children: ReactNode;
  className?: string;
  variant?: "default" | "strong" | "subtle";
  neonBorder?: boolean;
  hoverGlow?: "pink" | "cyan" | "purple" | "blue" | "green" | "orange" | "red" | "none";
  padding?: "none" | "sm" | "md" | "lg";
  onClick?: () => void;
}

const paddingMap = {
  none: "",
  sm: "p-3",
  md: "p-5",
  lg: "p-7",
};

const hoverGlowMap = {
  pink: "hover:shadow-[0_0_20px_rgba(255,16,240,0.2)]",
  cyan: "hover:shadow-[0_0_20px_rgba(0,255,255,0.2)]",
  purple: "hover:shadow-[0_0_20px_rgba(189,0,255,0.2)]",
  blue: "hover:shadow-[0_0_20px_rgba(0,128,255,0.2)]",
  green: "hover:shadow-[0_0_20px_rgba(57,255,20,0.2)]",
  orange: "hover:shadow-[0_0_20px_rgba(255,107,0,0.2)]",
  red: "hover:shadow-[0_0_20px_rgba(255,7,58,0.2)]",
  none: "",
};

export function GlassCard({
  children,
  className,
  variant = "default",
  neonBorder = false,
  hoverGlow = "none",
  padding = "md",
  onClick,
}: GlassCardProps) {
  const variantClasses = {
    default: "bg-white/[0.08] backdrop-blur-xl border border-white/[0.1]",
    strong: "bg-white/[0.15] backdrop-blur-2xl border border-white/[0.2]",
    subtle: "bg-white/[0.04] backdrop-blur-lg border border-white/[0.06]",
  };

  return (
    <div
      onClick={onClick}
      className={cn(
        "rounded-xl transition-all duration-300",
        variantClasses[variant],
        paddingMap[padding],
        hoverGlowMap[hoverGlow],
        neonBorder && "neon-border",
        onClick && "cursor-pointer",
        className,
      )}
    >
      {children}
    </div>
  );
}
